import { HANDLE_ERROR } from './types';

export const handleError = payload => {
    console.error(payload);
    return {
        type: HANDLE_ERROR,
        payload,
    };
};
